export const letters = [
    {
        id: 1,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 2,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 3,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 4,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 5,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 6,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
    {
        id: 7,
        letterName: "Storm Follow Up",
        createdOn: "02/26/2023 09:44 PM ",
    },
];